//sets up routes for the module
//lazy loads
// When we finish the landing page, this condition should be deleted
const LandingPage = () => import('@/modules/core/views/LandingPage');


const routes = [
  {
    path: '/',
    alias: '/home',
    name: 'Landing Page',
    component: LandingPage,
    meta: {
      namespaces: ['core-site', "components"],
    }
  }
]

export default routes;